import { type OnInit, Component, inject } from '@angular/core';
import { FirebaseService } from '../../core/services/firebase.service';
import { ModalService } from '../../core/services/modal.service';

import { MenuItemHeaderComponent } from '../../shared/components/menu-item-header/menu-item-header.component';
import { OrderTemplateComponent } from './order-template.component';


@Component({
    selector: 'app-order-online',
    templateUrl: './order-online.component.html',
    styleUrls: ['./order-online.component.scss'],
    imports: [MenuItemHeaderComponent, OrderTemplateComponent]
})
export class OrderOnlineComponent implements OnInit {
  firebaseService = inject(FirebaseService);
  modalService = inject(ModalService);


  allMenuItems: {id: string; data: Record<string, unknown>}[] = [];

  entreeMenu: {id: string; data: Record<string, unknown>}[] = [];
  trendingMenu: {id: string; data: Record<string, unknown>}[] = [];
  lunchMenu: {id: string; data: Record<string, unknown>}[] = [];
  breakfastMenu: {id: string; data: Record<string, unknown>}[] = [];
  dinnerMenu: {id: string; data: Record<string, unknown>}[] = [];
  cateringMenu: {id: string; data: Record<string, unknown>}[] = [];
  weeklyCateringMenu: {id: string; data: Record<string, unknown>}[] = [];

  isLoaded = false;

  ngOnInit() {
    this.getMenuData();
    this.firebaseService.getViewPort().subscribe((d) => {
      if (d === 'menu') {
        const elmnt = document.getElementById(d);
        elmnt.scrollIntoView();
      }
    });
  }


  getMenuData(){
    this.firebaseService.getAllMenuItems().subscribe(data => {
      this.allMenuItems = data.map(x => ({ id: x.id, data: x.data() as Record<string, unknown> }));
      
      this.lunchMenu = this.allMenuItems.filter(x => x.data.section === 'lunch' && x.data.isVisible);
      this.entreeMenu = this.allMenuItems.filter(x => x.data.section === 'entree' && x.data.isVisible);
      this.trendingMenu= this.allMenuItems.filter(x => x.data.section === 'trending' && x.data.isVisible);
      this.breakfastMenu= this.allMenuItems.filter(x => x.data.section === 'breakfast' && x.data.isVisible);
      this.dinnerMenu= this.allMenuItems.filter(x => x.data.section === 'dinner' && x.data.isVisible);
      this.cateringMenu= this.allMenuItems.filter(x => x.data.section === 'catering' && x.data.isVisible);
      this.weeklyCateringMenu= this.allMenuItems.filter(x => x.data.section === 'weeklycatering' && x.data.isVisible);
      this.isLoaded = true;
    });
  }

  menuClicked(item: unknown) {
    this.firebaseService.setValue(item);
  }

}

